export function clientInfo() {
    const version = window.buildVersion || process.env.VERSION
    const launchDate = window.launchDate || process.env.BUILD_TIME

    return { version, launchDate }
}
